export { Primitive, primitiveClassName } from './Primitive';
